<div class="relative">
  <!-- Loader overlay (only shows when loading) -->
  <tui-loader [overlay]="true" [showLoader]="isLoading"></tui-loader>

  <!-- Main container -->
  <div class="container" *ngIf="!isLoading">
    <!-- Header -->
    <div class="flex gap-3 border-b border-b-accent pb-2">
      <button style="cursor: pointer" class="p-2" (click)="navigateToView()">
        <tui-svg
          src="tuiIconArrowLeftCircleLarge"
          style="color: black"
          class="hover:scale-110 transition-all duration-100"
        ></tui-svg>
      </button>
      <p class="flex items-center text-black text-[1.5rem] font-bold">
        New Announcement
      </p>
    </div>

    <!-- Form Section -->
    <div
      class="flex items-center justify-center xl:justify-normal mt-5 2xl:my-10 lg:ml-10"
    >
      <div class="w-full sm:w-[400px]">
        <form [formGroup]="announcementForm">
          <!-- Subject Field -->
          <div>
            <label for="subject" class="text-black">Subject</label>
            <tui-input
              formControlName="subject"
              tuiTextfieldSize="l"
              [tuiTextfieldCleaner]="true"
              [tuiTextfieldLabelOutside]="true"
              class="tui-space_top-1"
              [style.color]="'black'"
            >
              <input autocomplete="subject" tuiTextfield type="text" />
              Subject
            </tui-input>
            <tui-error
              formControlName="subject"
              [error]="[] | tuiFieldError | async"
            ></tui-error>
          </div>

          <!-- Recipient Field -->
          <div class="mt-4">
            <label for="recipient" class="text-black">Recipient</label>
            <tui-select
              formControlName="recipient"
              [valueContent]="recipientContent"
              placeholder="Select a recipient"
            >
              Recipient
              <tui-data-list-wrapper
                *tuiDataList
                [itemContent]="recipientContent"
                [items]="recipientOptions"
              />
            </tui-select>
            <tui-error
              formControlName="recipient"
              [error]="[] | tuiFieldError | async"
            ></tui-error>

            <ng-template #recipientContent let-item>
              <div>
                <span>{{ item.label }}</span>
              </div>
            </ng-template>
          </div>

          <!-- Message Field -->
          <div class="mt-4 flex flex-col">
            <label for="message" class="text-black">Message</label>
            <textarea
              class="bg-white text-black rounded-lg border-[1px] border-[#D8D8D8] hover:border-[#bb0021] hover:border-2 p-2"
              formControlName="message"
              rows="5"
              placeholder="Type your message here..."
            ></textarea>
            <tui-error
              formControlName="message"
              [error]="[] | tuiFieldError | async"
            ></tui-error>
          </div>

          <!-- Buttons -->
          <div class="flex gap-3 mt-5">
            <div class="w-full h-full">
              <button
                (click)="cancel()"
                tuiButton
                appearance="secondary"
                type="button"
                class="w-full h-full text-[#bb0021] hover:bg-[#faf0f2] hover:text-[#bb0021]"
              >
                Cancel
              </button>
            </div>
            <div class="w-full">
              <button
                tuiButton
                appearance="primary"
                type="button"
                class="w-full"
                (click)="onSubmit()"
                [showLoader]="isLoading"
              >
                <span class="text-white">Add Announcement</span>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
